import { render, staticRenderFns } from "./TablesCongress.vue?vue&type=template&id=f4eadf3a&scoped=true"
import script from "./TablesCongress.vue?vue&type=script&lang=js"
export * from "./TablesCongress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eadf3a",
  null
  
)

export default component.exports